// components/MenuItemsTable/DishCard.js
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const DishCard = ({
  item,
  cartItems,
  quantities,
  favorites,
  activeTooltip,
  onToggleTooltip,
  onAddToFavorites,
  onIncreaseQuantity,
  onDecreaseQuantity,
  onAddToCart,
  onOpenAddon,  
  handleOpenAddon,    // <-- NEW
  getAuthVars,
  setShowLogin
}) => {
  const isOutOfStock = Number(item.balanceQuantity) <= 0;
  const cartItem = cartItems.find(ci => ci.dishId === item.dishId);
  const qty = cartItem ? (quantities[cartItem.itemId] || cartItem.quantity || 0) : 0;

  const [openAddon, setOpenAddon] = useState(false);
const [selectedAddons, setSelectedAddons] = useState([]);


const handleAddonSelection = (addon) => {
  const exists = selectedAddons.find(
    (a) => a.addonId === addon.addonId
  );

  if (exists) {
    setSelectedAddons(
      selectedAddons.filter(
        (a) => a.addonId !== addon.addonId
      )
    );
  } else {
    setSelectedAddons([...selectedAddons, addon]);
  }
};

const handleConfirm = () => {
  onAddToCart(item, 1, false, selectedAddons);

  setOpenAddon(false);

  setSelectedAddons([]);
};

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (!isOutOfStock) onAddToFavorites(item.dishId);
  };

  const handleInfoClick = (e) => {
    e.stopPropagation();
    onToggleTooltip(item.dishId, item.description);
  };

  const handleDecrease = () => {
    onDecreaseQuantity(item);
  };

  const handleIncrease = () => {
    onIncreaseQuantity(item.dishId, item);
  };

  const handleAddToCart = async () => {
  const { userId } = getAuthVars();

  if (!userId) {
    setShowLogin(true);
    return;
  }

  // Agar addons available hain to popup open karo
  if (item?.addons?.length > 0) {
    setOpenAddon(true);
    return;
  }

  // Direct API call
  await onAddToCart(item, 1, false, []);
};

  const handleScheduleNow = () => {
    const { userId } = getAuthVars();
    if (!userId) {
      setShowLogin(true);
      return;
    }
    onAddToCart(item, 1, true);
  };


  

  return (
    <div className="offers-cards" style={{
      position: "relative",
      borderRadius: "16px",
      overflow: "hidden",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "pointer",
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
    }}>
      {/* Favorite Button */}
      <div style={{
        position: "absolute",
        top: "12px",
        right: "12px",
        zIndex: 15,
        backgroundColor: "rgba(255,255,255,0.9)",
        borderRadius: "50%",
        width: "36px",
        height: "36px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: isOutOfStock ? "not-allowed" : "pointer",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
      }} onClick={handleFavoriteClick}>
        <i className="fa-regular fa-heart" style={{
          fontSize: "18px",
          color: favorites.includes(item.dishId) ? "#dc2626" : "#ee6521"
        }} />
      </div>

      {/* Image */}
      <div style={{ position: "relative", pointerEvents: isOutOfStock ? "none" : "auto" }}>
        <img src={item.dishImage || "default-image.jpg"} alt="Dish"
          style={{ width: "100%", height: "180px", objectFit: "cover" }} />
        {isOutOfStock && (
          <div style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontWeight: "700"
          }}>
            OUT OF STOCK
          </div>
        )}
      </div>

      {/* Card Body */}
      <div style={{ padding: "14px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
          <h5 style={{ fontSize: "16px", fontWeight: "700", color: "#ee6521", margin: 0, flex: 1 }}>
            {item.dishName}
          </h5>
          <div style={{
            marginLeft: "8px",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            backgroundColor: "#ee6521",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            cursor: "pointer"
          }} onClick={handleInfoClick}>i</div>
          <span style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "18px",
            height: "18px",
            border: `2px solid ${item.tag === "Veg" ? "#2e7d32" : "#d32f2f"}`,
            borderRadius: "2px",
            marginLeft: "8px",
            position: "relative"
          }}>
            <span style={{
              width: "8px",
              height: "8px",
              backgroundColor: item.tag === "Veg" ? "#2e7d32" : "#d32f2f",
              borderRadius: "50%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)"
            }} />
          </span>
        </div>

        {/* Tooltip */}
        {activeTooltip === item.dishId && (
          <div style={{
            background: '#fff8f5',
            border: '1px solid #ee6521',
            borderRadius: '8px',
            padding: '8px',
            fontSize: '12px',
            color: '#555',
            marginBottom: '8px'
          }}>
            {item.description || 'No description available.'}
          </div>
        )}

        {/* Price */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
          {item.effectivePrice !== undefined && item.effectivePrice > 0 ? (
            <>
              <span style={{ fontSize: "14px", color: "#999", textDecoration: "line-through" }}>₹{item.price}</span>
              <span style={{ fontSize: "20px", fontWeight: "bold", color: "#2e7d32" }}>₹{item.effectivePrice.toFixed(2)}</span>
            </>
          ) : (
            <span style={{ fontSize: "20px", fontWeight: "bold", color: "#2e7d32" }}>₹{item.price}</span>
          )}
        </div>

        {/* Action Buttons */}
        {isOutOfStock ? (
          <button onClick={handleScheduleNow}
            style={{
              background: "#ff9800",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "600",
              border: "none",
              width: "100%",
              padding: "10px",
              borderRadius: "25px",
              cursor: "pointer"
            }}>
            Schedule Now
          </button>
        ) : qty > 0 ? (
          <div style={{
            borderRadius: "50px",
            backgroundColor: "#ee6521",
            width: "100%",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
            <button onClick={handleDecrease}
              style={{
                color: "#fff",
                fontSize: "22px",
                fontWeight: "bold",
                width: "40px",
                height: "100%",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              }}>-</button>
            <span style={{ fontSize: "18px", fontWeight: "bold", color: "#fff" }}>{qty}</span>
            <button onClick={handleIncrease}
              style={{
                color: "#fff",
                fontSize: "22px",
                fontWeight: "bold",
                width: "40px",
                height: "100%",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              }}>+</button>
          </div>
        ) : (
          <button
  onClick={handleAddToCart}
  style={{
    background: "#ee6521",
    color: "#fff",
    width: "100%",
    padding: "10px",
    border: "none",
    borderRadius: "25px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer"
  }}
>
  Add To Cart
</button>
        )}
      </div>

      <Dialog
  open={openAddon}
  onClose={() => setOpenAddon(false)}
  maxWidth="sm"
  fullWidth
>

  <DialogTitle>
    {item.dishName}
  </DialogTitle>

  <DialogContent>

   {item.addons?.map((addon) => (

      <FormControlLabel
        key={addon.addonId}
        control={
          <Checkbox
            checked={selectedAddons.some(
              (a) => a.addonId === addon.addonId
            )}
            onChange={() => handleAddonSelection(addon)}
          />
        }
        label={`${addon.addonName} (+₹${addon.addonPrice})`}
      />

    ))}

  </DialogContent>

  <DialogActions>

    <Button
      onClick={() => setOpenAddon(false)}
    >
      Cancel
    </Button>

    <Button
      variant="contained"
      onClick={handleConfirm}
    >
      Add To Cart
    </Button>

  </DialogActions>

</Dialog>
    </div>
  );
};

export default DishCard;